/**
 * Carousel Slides Data
 *
 * This file contains all the content for the homepage carousel.
 * You can easily add, edit, or remove slides by modifying this array.
 *
 * To add a new slide:
 * 1. Add your image to /public/images/carousel/
 * 2. Copy an existing slide object and modify the values
 * 3. The carousel will automatically include it
 *
 * To change the order:
 * - Simply rearrange the slide objects in the array
 *
 * Image recommendations:
 * - Size: 1200x800px or similar ratio (3:2)
 * - Format: JPG or PNG
 * - Keep file size under 500KB for fast loading
 */

export interface CarouselSlide {
  id: number;
  image: string;           // Path to image (from /public folder)
  imageAlt: string;        // Alt text for accessibility
  label: string;           // Small text above heading
  heading: string;         // Main heading
  description: string;     // Description text
  buttonText: string;      // Call-to-action button text
  buttonLink: string;      // Where the button links to
  gradient: string;        // Fallback gradient if image not loaded
}

export const carouselSlides: CarouselSlide[] = [
  {
    id: 1,
    image: '/images/carousel/promotion.jpg',
    imageAlt: 'Trading cards promotion',
    label: 'Special Promotion',
    heading: 'Open Promotion',
    description: 'Any buy/sell is free in this period. Start trading without any fees!',
    buttonText: 'Start Trading Now',
    buttonLink: '/marketplace',
    gradient: 'from-blue-500 to-blue-700',
  },
  {
    id: 2,
    image: '/images/carousel/community.jpg',
    imageAlt: 'Join trading community',
    label: 'Join Our Community',
    heading: 'Welcome to Trading Website',
    description: 'Please help report card prices and you will get rewards for your contribution',
    buttonText: 'Learn More',
    buttonLink: '/leaderboard',
    gradient: 'from-purple-500 to-blue-600',
  },
  {
    id: 3,
    image: '/images/carousel/new-arrivals.jpg',
    imageAlt: 'Latest card arrivals',
    label: 'New This Week',
    heading: 'Latest Card Arrivals',
    description: 'Discover the newest and most sought-after trading cards in our marketplace',
    buttonText: 'Browse New Cards',
    buttonLink: '/browse-cards',
    gradient: 'from-teal-500 to-blue-600',
  },
  {
    id: 4,
    image: '/images/carousel/analytics.jpg',
    imageAlt: 'Market price analytics',
    label: 'Market Insights',
    heading: 'Track Market Prices',
    description: 'Monitor real-time prices and historical trends with our interactive charts',
    buttonText: 'View Analytics',
    buttonLink: '/browse-cards',
    gradient: 'from-blue-600 to-indigo-700',
  },
];

/**
 * Carousel Settings
 *
 * Adjust these values to change carousel behavior
 */
export const carouselSettings = {
  autoPlayInterval: 5000,  // Time between slides (milliseconds)
  transitionDuration: 500, // Animation speed (milliseconds)
  pauseOnHover: true,      // Pause auto-play when hovering
};
